import StateSetView from './StateSetView';
import './StateSetView.scss';

export default StateSetView;
